import { getTableColumns } from '../../Table/utils';

function getEarningsTableColumns() {
  return getTableColumns([
    { accessor: 'user_email', header: 'Contributor' },
    { accessor: 'purchase_date', header: 'Date', type: 'date' },
    { accessor: 'price', header: 'Amount', type: 'amount' },
  ]);
}

export { getEarningsTableColumns };
